@if (content$ | async; as content) {
  <div class="maintenance-period-card">
    <h4>
      {{ 'MAINTENANCE_PERIOD_MODAL_TITLE' | translate }}
    </h4>
    <p>{{ content }}</p>
  </div>
}
